module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4wMcDAEVfLd9tQAAAKNJREFUWMPt0DEKwkAUBNAZCZIm2JjOPjfxAJIynYdIlzNp4R08giDY2KdYSIogjn3YwmIDIjOwzfBhHktEImkPYIPl8iR5nZeMYsbxjr7fIYRXckZZrlEUF+b54at7hfBQXUtA+td10jCcYrsr/FCMMcYYY4wxxhhjjDHGGGOMMcaYP8Zk0ZYU2nZC07yTL1ZVBlLR2Vgp6Qhgu+An3Eie5+UHHBNRBuU6JCMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/redcard.png
// module id = 213
// module chunks = 0